import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

const services = document.querySelectorAll(".service-swiper");

services.forEach((service) => {
    const className = Array.from(service.classList).find((c) => c.startsWith("title-"));
    const serviceSwiper = new Swiper(`.${className}`, {
        direction: "horizontal",
        loop: false,
        pagination: {
            clickable: true,
            el: ".swiper-pagination",
        },
    });
});
